import "./TrainManageDialog.less"
import { CloseBtn } from "../CloseBtn/CloseBtn";
import { useState } from "react";
import { Switch } from "antd";
import Images from "../../utils/Images";
import { ColorImg } from "../ColorImg/ColorImg";
import { inject, observer } from "mobx-react";
import getStoreFromProps from "../../store/getStoreFromProps";
import { customScrollbar } from "../../utils/misc";
import { MSG_TYPE, msgbox } from "../../utils/Msgbox";

type TrainManageDialogProps = {
    onClose: () => void;
    onPublishClick: () => void;
};

export const TrainManageDialog = inject("trainManage", "common")(observer((props: TrainManageDialogProps): React.ReactElement => {
    const [isBatch, setIsBatch] = useState(false);
    const [batchId, setBatchId] = useState(new Set<string>());
    const trainManageStore = getStoreFromProps(props, "trainManage");
    const commonStore = getStoreFromProps(props, "common");

    const onDeleteClick = (): void => {
        if(batchId.size <= 0){
            return;
        }

        msgbox("确定删除", MSG_TYPE.INFO, () => {
            commonStore.runWithLoadingAnim(trainManageStore.deleteModel(Array.from(batchId)).then(() => {
                setBatchId(new Set<string>());
            }));
        });
    };

    const onDownloadClick = (): void => {
        commonStore.runWithLoadingAnim(trainManageStore.downloadModel(Array.from(batchId)));
    };

    const topBtnInfo: any[][] = [
        [Images.deleteIcon1, "删除", onDeleteClick, () => batchId.size > 0],
        [Images.download, "下载", onDownloadClick, () => batchId.size === 1],
        // [Images.publish, "发布", props.onPublishClick, () => batchId.size === 1]
    ];

    // 批处理状态变化
    const onBatchStateChange = (a: boolean): void => {
        setIsBatch(a);
        if(a){
            setBatchId(new Set<string>(trainManageStore.history.map(h => h.id)));
        } else {
            setBatchId(new Set<string>());

        }
    };

    // 单个模型选择
    const onBatchIdChange = (a: string): void => {
        if(batchId.has(a)){
            batchId.delete(a);
        } else {
            batchId.add(a);
        }
        setBatchId(new Set<string>(batchId));
    };

    return <div className="fullscreen-dialog-bg-color fullscreen-mask">
        <div className="train-manage-dialog">
            <CloseBtn onClick={props.onClose}></CloseBtn>
            <div className="train-manage-top-wrap">
                <div className="train-manage-select-all-text">全选</div>
                <Switch className="train-manage-select-all-switch" value={isBatch} onChange={onBatchStateChange}></Switch>
                <div className="train-manage-select-count">
                    <span>已选中</span>
                    <span>{batchId.size}</span>
                </div>
                {topBtnInfo.map((item, i) =>
                    <div key={i} data-active={item[3]()} className="train-manage-top-btn" onClick={item[2]}>
                        <ColorImg src={item[0]}></ColorImg>
                        <span>{item[1]}</span>
                    </div>)}
            </div>
            <div className={`train-manage-history-wrap ${customScrollbar}`}>
                {trainManageStore.history.map((item, i) =>
                    <div key={i} className="train-manage-history-item">
                        <div className="train-manage-history-item-top">
                            <img src={Images.expand}></img>
                            <span>{item.name}</span>
                            <span>{item.createTime}</span>
                            {/* <span>{`共${(item.size / (1 << 30)).toFixed(1)}GB`}</span> */}
                        </div>
                        <div className="train-manage-history-item-models-wrap">
                            {item.models.map((model, j) =>
                                <div key={j} data-hoverable={!isBatch} className="train-manage-history-item-model" style={{"--img": `url(${model.cover})`} as React.CSSProperties}>
                                    <span className="train-manage-history-item-model-name">{model.name}</span>
                                    {/* <span className="train-manage-history-item-model-size">{`${model.size >> 20}MB`}</span> */}
                                    <div data-select={batchId.has(item.id)} data-visible={batchId.has(item.id) || isBatch} className="train-manage-history-item-model-circle" style={{"--img": `url(${Images.mark})`} as React.CSSProperties}
                                         onClick={() => onBatchIdChange(item.id)}></div>
                                </div>)}
                        </div>
                    </div>)}
            </div>
        </div>
    </div>;
}));